/* footer-custom.js - JS for footer accordion behavior (scoped) */
(function(){
  function initAccordion(root){
    if (!root) return;
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    var cols = root.querySelectorAll('.footer-column');
    cols.forEach(function(col){
      var title = col.querySelector('.section-title');
      if (!title) return;
      if (title.getAttribute('data-has-listener')) return;
      title.setAttribute('data-has-listener','1');
      title.addEventListener('click', function(){ col.classList.toggle('open'); });
    });
  }

  function initAll(){
    document.querySelectorAll('.footer-custom').forEach(function(root){ initAccordion(root); });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('resize', initAll);
})();
